import React from 'react';
import { Carousel } from 'antd';

import cansatPrototype from '../../../../Assets/Linkages/StudentSatelliteOutreach/Introduction/student-cansat-prototype.jpg';
import satelliteElectronics from '../../../../Assets/Linkages/StudentSatelliteOutreach/Introduction/student-satellite-electronics.jpg';

const StudentSatelliteIntroduction = () => (
  <section className="student-satellite-introduction" aria-labelledby="student-satellite-introduction-title">
    <div className="student-satellite-introduction-inner">
      <div className="student-satellite-introduction-copy">
        <p className="section-eyebrow">BUILD. TEST. DISCOVER.</p>
        <h2 id="student-satellite-introduction-title">Introduction</h2>
        <div className="world-space-week-title-line" aria-hidden="true" />

        <p>
          The Student Satellite Design, Development and Launch initiative is a specialized outreach
          program dedicated to advancing knowledge in satellite technology and its applications within
          the broader domain of space science and technology. Spearheaded by the Space Education Research
          Lab of the National Center of GIS &amp; Space Applications (NCGSA), this program is designed to
          inspire and equip students through hands-on experiences and interactive learning.
        </p>
        <p>
          Through a series of engaging workshops, technical trainings, seminars, webinars, destination
          school visits, and national-level competitions, students from grades 9–12 as well as
          undergraduate levels actively participate in the end-to-end process of building educational
          satellites, including CanSats and CubeSats. These student-built satellites simulate the core
          functionalities of real-world satellites, offering an immersive learning experience that
          bridges theoretical knowledge with practical application.
        </p>
      </div>

      <div className="student-satellite-introduction-gallery" aria-label="Student satellite prototypes">
        <Carousel autoplay autoplaySpeed={3500} pauseOnHover dots effect="fade">
          <figure>
            <img src={cansatPrototype} alt="Student-built CanSat prototype" />
          </figure>
          <figure>
            <img src={satelliteElectronics} alt="Electronics developed for a student satellite system" />
          </figure>
        </Carousel>
      </div>
    </div>
  </section>
);

export default StudentSatelliteIntroduction;
